import styled from "styled-components";

import { ConsolePageButtonStyles } from "@Console/components/molecules/ConsolePageForm/atoms/ConsolePageButton/styles";

export const ConsoleGroupModerationHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  @media (max-width: 1000px) {
    align-items: flex-start;
  }

  @media (max-width: 600px) {
    align-items: flex-start;
  }
`;

export const GoToGroupButton = styled(ConsolePageButtonStyles)`
  background-color: ${({ theme }) =>
    theme.mode === "dark" ? "#ffffff" : "#000000"}0a !important;
  color: ${({ theme }) => theme.console.pageTitleColor};
  padding: 0;

  border: 1px solid
    ${({ theme }) => (theme.mode === "dark" ? "#ffffff" : "#000000")}14;

  a {
    padding: 0.5rem 1rem;
  }
`;
